/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IHospital } from 'app/shared/model/hospital.model';

export interface IDoctorHospitalAssociation {
  id?: string;
  joiningDt?: number;
  leavingDate?: number | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  dutyStartTime?: string | null;
  dutyEndTime?: string | null;
  tmPermanent?: boolean | null;
  createdDtm?: number | null;
  lastModifiedDtm?: number | null;
  createdBy?: string | null;
  modifiedBy?: string | null;
  leavingDt?: number | null;
  doctor?: IDoctor;
  hospital?: IHospital;
}

export const defaultValue: Readonly<IDoctorHospitalAssociation> = {
  active: false,
  tmPermanent: false,
};
